// import Layout from '@/page/layout/home'
import LayoutNoFooter from '@/page/layout/index'

export default [
    {
        path: '/device-my',
        name: 'deviceMy',
        component: LayoutNoFooter,
        children: [
            {
                path: 'index',
                name: 'deviceMyindex',
                component: () => import(/* webpackChunkName: "big-screen" */ '@/views/device-my/index'),
                meta: {
                    title: '设备管理',
                    isAuth: true,
                    keepAlive: true
                }
            },
            {
                path: 'detail',
                name: 'deviceMyDetail',
                component: () => import(/* webpackChunkName: "big-screen" */ '@/views/device-my/detail'),
                props: route => ({
                    deviceId: route.query.deviceId,
                }),
                meta: {
                    title: '设备详细',
                    isAuth: true,
                }
            },

        ]
    },
]
